import { put, select } from 'redux-saga/effects'
import { push } from 'react-router-redux'

import { getCurrentPartnerId, getIdentityPartners } from 'selectors/settings'
import { redirectAbsolutePath } from 'utils/redirect'
import { getPartnerUrl } from 'utils/urls'

export function* apiErrorsSaga(action) {
  if (action.error && action.error.detail) {
    if (action.error.detail.statusCode === 401) {
      // User is logged out, so redirect to login
      redirectAbsolutePath(`/login?next=${window.location.pathname}`)
    } else if (action.error.detail.statusCode === 403) {
      // User does not have permission, so either redirect to home or root
      const identityPartners = yield select(getIdentityPartners)
      const partnerId = parseInt(yield select(getCurrentPartnerId), 10)

      // If user has access to the partner, redirect to partner home
      if (identityPartners.includes(partnerId)) {
        yield put(push(getPartnerUrl(partnerId)))
      } else {
        redirectAbsolutePath('/')  // otherwise redirect to root
      }
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/sagas/errors/error-handling-sagas.js
 **/